const gridProfile = {
  gridProfile: {
    pageHeader: 'Perfil de rede',
    name: 'Nome',
    description: 'Descrição',
    createdBy: 'Criado por',
    noGrid: '** Sem redes disponíveis **',
    grids: 'Redes’'
  }
};

export default gridProfile;